import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { isIntegrationRegistrationSessionActive } from '../feature-flag/cfb-integration-registration.util';
import { CfbFeatureFlagService } from '../feature-flag/cfb-feature-flag.service';

export const cfbIntegrationOnCanMatch: CanMatchFn = () => {
  if (isIntegrationRegistrationSessionActive()) {
    return true;
  }

  return inject(CfbFeatureFlagService).isIntegrationOn();
};
